export default "__VITE_ASSET__CiQOvXZo__"